<script lang="ts" setup>
import { getPersonMedias } from '~/queries/person'
const { slug } = useResourceSlug()
const { formatToFullDate } = useFullDateFormater()
const { data, pending, error } = await useAsyncData(`/person/${slug}`, () =>
  execQuery(() => getPersonMedias(), {
    slug,
  })
)
const person = computed(() => {
  if (pending.value || error.value) return null
  return data.value.data.personMedias
})
function formatMedia(media) {
  if (!media) return null
  return {
    subtitle: media.description,
    excerpt: `${media.timestamp ? formatToFullDate(media.timestamp) : ''} ${media.duration ?? ''
      }`,
    ...media,
  }
}
</script>
<template>
  <DetailComposer :resume="person?.resume" :composer="person" :hide-outline="true">
    <div class="pt-6 md:pt-0">
      <p class="text-mobile-lg text-shade-500">
        {{ $t('search.total_result', person?.medias?.length) }}
      </p>
      <div class="divide-y divide-shade-200">
        <ListResource v-for="(result, i) in person?.medias?.map(formatMedia)" :key="i" :resource="result"
          class="py-4" />
      </div>
    </div>
  </DetailComposer>
</template>
